
import { mapState } from 'vuex'
import LayoutMixin from '@/mixins/layout'
import { formatTimeWithMoment } from '@/utils/date'
import noOrderApp from '@/assets/img/service-support/no_order_app.png'
import noOrderPC from '@/assets/img/service-support/no_order_pc.png'
import { isHiddenHeaderFn } from '@/utils/utils'
export default {
  components: {},
  mixins: [LayoutMixin],
  data() {
    return {
      noOrderApp,
      noOrderPC,
      current: {},
      up: '',
      down: '',
      wbUrl: '',
      qqUrl: '',
      itemName: '',
      isLoaded: false,
      isPromotion: false,
    }
  },
  computed: {
    ...mapState({
      isHdFtMobile: (state) => state.isHdFtMobile,
    }),
    // 判断是否需要隐藏公共部分
    isHiddenHeader() {
      return isHiddenHeaderFn(this.$route)
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.getDetail()
        this.setLogger()
      },
    },
  },
  created() {},
  mounted() {
    this.setLogger()
    this.getDetail()
  },
  methods: {
    setLogger() {
      const tab = this.$route.query.tab
      // let key = ''
      switch (tab) {
        case 'board': // 服务公告
          this.itemName = this.$t('modules.about.news_infos.moreNotice')
          // key = 'announcement_detail_page|服务公告内容页面'
          break
        case 'news': // 新闻动态
          this.itemName = this.$t('modules.about.news_infos.moreTitle')
          // key = 'press_detail_page|新闻动态内容页面'
          break
        case 'promotion': // 推广专区
          this.itemName = this.$t('modules.about.news_infos.morePromotion')
          // key = 'promotion_detail_page|推广专区内容页面'
          break
      }
      // this.$logger.customTrack({
      //   type: 'visit',
      //   event: key,
      // })
    },
    formatTimeWithMoment,
    prev() {
      this.$router.go(-1)
    },
    async getDetail() {
      try {
        const w = window
        if (this.$route.query.tab === 'promotion') {
          this.isPromotion = true // 只有推广专区的图片需要居中显示
        } else {
          this.isPromotion = false
        }
        const res = await this.$API.about.getOneInformationWithAround({
          code: this.$route.query.code,
        })
        this.isLoaded = true
        this.current = res.current || {}
        this.up = res.up
        this.down = res.down
        this.wbUrl = `http://v.t.sina.com.cn/share/share.php?url=${w.location.href}&title=${this.current.title}`
        // this.wbUrl = `http://service.weibo.com/share/share.php?url=${w.location.href}&title=${this.current.title}`
        this.qqUrl = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${w.location.href}&title=${this.current.title}`
      } catch (e) {
        // console.log('getLiveOrigin error', e)
        this.isLoaded = true
      }
    },
    goUp() {
      this.$router.replace({
        path: `/${this.$route.params.site}/${this.$route.params.lang}/about/detail`,
        query: {
          code: this.up.code,
          tab: this.$route.query.tab,
        },
      })
    },
    goDown() {
      this.$router.replace({
        path: `/${this.$route.params.site}/${this.$route.params.lang}/about/detail`,
        query: {
          code: this.down.code,
          tab: this.$route.query.tab,
        },
      })
    },
  },
}
